import Button from './Button';
import Checkbox from './Checkbox';
import Divider from './Divider';
import Drawer from './Drawer';
import Input from './Input';
import Radio from './Radio';
import Stepper from './Stepper';
import Tabs from './Tabs';

const components = {
  Button,
  Checkbox,
  Input,
  Radio,
  Stepper,
  Tabs,
  Divider,
  Drawer
};

export default components;
